export default {

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      file: '',
      isProcessing: false,
      isControlled: false,
      error: false,
      responseErr: '',
      fileName: '',
      productviolations: [],
      productdifferences: [],
      errormessages: []
    }
  },

  mounted () {
    this.$store.dispatch('params/reset')
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },
    handleFileUpload () {
      this.error = false
      this.errormessages = []
      this.productviolations = []
      this.productdifferences = []
      this.$store.dispatch('params/reset')
      this.isControlled = false
      this.file = this.$refs.file.files[0]
      this.fileName = this.file.name
    },

    async submitFile () {
      if (this.isControlled || this.error) {
        this.fileName = ''
        this.errormessages = []
        this.productviolations = []
        this.productdifferences = []
      }
      this.error = false
      if (this.file) {
        this.isProcessing = true
        this.controlParam(this.file).then(() => {
          const fileinput = this.$refs.file
          fileinput.type = 'text'
          fileinput.type = 'file'
          this.file = undefined
        })
      } else {
        this.error = true
        this.$store.dispatch('params/reset')
        this.responseErr = 'PARAM_CONTROL_NO_FILE_SELECTED'
      }
    },

    async toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    async controlParam (fileTocontrol) {
      const file = await this.toBase64(fileTocontrol)
      await this.$store.dispatch('params/reset')
      await this.$store.dispatch('params/control', file).then(
        () => {
          this.isControlled = true
          this.productviolations = this.$store.state.params.paramResponse.checkProductListOutput.productViolations
          this.productdifferences = this.$store.state.params.paramResponse.checkProductListOutput.productDifferences
          this.errormessages = this.$store.state.params.paramResponse.errorMessages
          this.isProcessing = false
        },
        error => {
          this.error = true
          this.responseErr = error.response
          this.responseErr = 'PARAM_CONTROL_ERROR'
          this.isProcessing = false
        }
      )
    }
  }
}
